@if (!navigationHidden) {
  <app-header></app-header>
}
<app-loading-indicator class="w-100"></app-loading-indicator>

<main role="main">
  <!--initial loading indicator while guards/resolvers are loading-->
  @if (loadingIndicatorService.isInitiallyLoading || !designSystemsLoaded) {
    <app-loading-indicator></app-loading-indicator>
    <section class="section section-square-pattern"></section>
  }

  @if (!loadingIndicatorService.isInitiallyLoading && designSystemsLoaded) {
    <router-outlet></router-outlet>
  }
</main>

@if (magentaSSOKeepAliveEndpoint) {
  <iframe
    [src]="magentaSSOKeepAliveEndpoint | safe: 'url'"
    height="0"
    width="0"
    style="display: none; visibility: hidden"
  ></iframe>
}

@if (!navigationHidden) {
  <app-footer></app-footer>
}
